var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 44.299 44.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google",
    transform: "translate(31.851 31.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-2",
    "data-name": "google",
    transform: "translate(-31.851 -31.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-3",
    "data-name": "google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,0H44.3V44.3H0",
    fill: "#f0f0f0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M29.8,23.527a9.88,9.88,0,0,1-8.069,7.048A11.027,11.027,0,0,1,9.176,20.8,10.759,10.759,0,0,1,19.934,9.181,10.972,10.972,0,0,1,24,9.97a.9.9,0,0,0,1.148-.377l2.582-4.752a.933.933,0,0,0-.412-1.255A17.93,17.93,0,0,0,2,20.461,18.147,18.147,0,0,0,19.163,37.873a17.931,17.931,0,0,0,18.7-17V17.287a.915.915,0,0,0-.9-.9H20.83a.9.9,0,0,0-.9.9v5.38a.9.9,0,0,0,.9.9H29.8",
    transform: "translate(2.215 2.209)",
    fill: "#f0f0f0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f09dc197.svg";
export { ForwardRef as ReactComponent };